import React from "react"
import { Link } from "gatsby"
import "./index.css"

const FooterBottom = () => {
  return (
    <section id="footer-bottom-section">
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <ul className="footer-bottom-nav">
              <li>
                <Link to="/">FAQ</Link>
              </li>
              <li>
                <Link to="/">AGB</Link>
              </li>
              <li>
                <Link to="/">IMPRESSUM</Link>
              </li>
              <li>
                <Link to="/">DATENSCHUTZ</Link>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul className="footer-bottom-social">
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-twitter" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://tripadvisor.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-tripadvisor" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-youtube-play"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FooterBottom
